import React from 'react';

const BundlesShopIcon: React.FC = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.668 2.98779H3.33464C2.89261 2.98779 2.46868 3.16339 2.15612 3.47595C1.84356 3.78851 1.66797 4.21243 1.66797 4.65446V6.32113C1.66972 6.61198 1.74757 6.89732 1.89376 7.14877C2.03995 7.40022 2.24941 7.60903 2.5013 7.75446V16.3211C2.5013 16.7632 2.6769 17.1871 2.98946 17.4996C3.30202 17.8122 3.72594 17.9878 4.16797 17.9878H15.8346C16.2767 17.9878 16.7006 17.8122 17.0131 17.4996C17.3257 17.1871 17.5013 16.7632 17.5013 16.3211V7.75446C17.7532 7.60903 17.9627 7.40022 18.1088 7.14877C18.255 6.89732 18.3329 6.61198 18.3346 6.32113V4.65446C18.3346 4.21243 18.159 3.78851 17.8465 3.47595C17.5339 3.16339 17.11 2.98779 16.668 2.98779ZM3.33464 4.65446H16.668V6.32113H3.33464V4.65446ZM4.16797 16.3211V7.98779H15.8346V16.3211H4.16797Z'
        fill='#C7C6CF'
      />
      <path
        d='M6.66797 9.65454H13.3346V11.3212H6.66797V9.65454Z'
        fill='#C7C6CF'
      />
    </svg>
  );
};

export default BundlesShopIcon;
